import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { GraduationCap, Calendar, MapPin } from 'lucide-react';
import { profileData } from '../data/mock';

const Education = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            <span className="text-[#00AFF0]">Education</span>
          </h2>
          <div className="w-20 h-1 bg-[#00AFF0] mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Strong academic foundation in computer science and data analytics
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {profileData.education.map((edu, index) => (
            <Card
              key={edu.id}
              className="p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-2 hover:border-[#00AFF0]/50"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#00AFF0] to-[#0099D6] flex items-center justify-center flex-shrink-0">
                  <GraduationCap className="w-7 h-7 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">
                    {edu.degree}
                  </h3>
                  <p className="text-[#00AFF0] font-semibold mb-2">{edu.field}</p>
                  <p className="text-gray-700 font-medium mb-3">{edu.institution}</p>
                  <div className="flex flex-wrap gap-3 text-sm text-gray-600">
                    <span className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      {edu.duration}
                    </span>
                    <span className="flex items-center gap-1">
                      <MapPin className="w-4 h-4" />
                      {edu.location}
                    </span>
                  </div>
                </div>
              </div>

              <div className="pt-4 border-t border-gray-100">
                <p className="text-sm font-semibold text-gray-700 mb-3">Key Skills Acquired:</p>
                <div className="flex flex-wrap gap-2">
                  {edu.skills.map((skill, idx) => (
                    <Badge
                      key={idx}
                      className="bg-[#00AFF0]/10 text-[#00AFF0] hover:bg-[#00AFF0]/20 transition-colors text-xs"
                    >
                      {skill}
                    </Badge>
                  ))}
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Testimonial Section */}
        <div className="mt-16">
          <Card className="p-8 border-2 border-[#00AFF0]/20 bg-gradient-to-br from-white to-[#00AFF0]/5">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#00AFF0] to-[#0099D6] flex items-center justify-center text-white text-2xl font-bold">
                  {profileData.testimonial.name.split(' ').map(n => n[0]).join('')}
                </div>
              </div>
              <div className="flex-1">
                <div className="mb-4">
                  <p className="text-gray-700 leading-relaxed italic text-lg">
                    "{profileData.testimonial.content}"
                  </p>
                </div>
                <div>
                  <p className="font-bold text-gray-900">{profileData.testimonial.name}</p>
                  <p className="text-gray-600">{profileData.testimonial.title}</p>
                  <p className="text-sm text-[#00AFF0] mt-1">{profileData.testimonial.relation}</p>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Education;